export default function numOrDefault(value) {
  const parsedValue = Number(value);

  if (isNaN(parsedValue)) {
    return 0;
  }
  return Number(parsedValue);
}
